import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from './services/spinner.service';

@Component({
   selector: 'silk-app',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.css'],
   encapsulation: ViewEncapsulation.None
})
export class SilkAppComponent {

   constructor(
      private router: Router,
      public translate: TranslateService,
      public spinnerService: SpinnerService,
      private changeDetectorRef: ChangeDetectorRef,) {
      this.router.events.subscribe((e: RouterEvent) => {
         this.navigationInterceptor(e);
      })
   }

   // console error clear
   ngAfterViewChecked() {
      this.changeDetectorRef.detectChanges();
   }

   ngOnInit() {

      this.translate.addLangs(['it', 'en']);

      this.translate.setDefaultLang('it');

      this.translate.use('it');
   }

   // Shows and hides the loading spinner during RouterEvent changes
   navigationInterceptor(event: RouterEvent): void {
      if (event instanceof NavigationStart) {
         this.spinnerService.start();
      }
      if (event instanceof NavigationEnd) {
         this.spinnerService.stop();
      }

      // Set loading state to false in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
         this.spinnerService.stop();
      }
      if (event instanceof NavigationError) {
         this.spinnerService.stop();
      }

   }
}
